import { requestGet, requestPost } from '@/utils/request';

const api = {
	LIST: '/system/product_list',
	DETAIL: '/system/product_detail',
	ADD: '/system/product_add',
	UPDATE: '/system/product_update',
	SET_ENABLE: '/system/product_set_enable',
};

export async function productList(queryParams) {
	return requestGet(api.LIST, queryParams);
}

export async function productDetail(id) {
	return requestGet(api.DETAIL, { id });
}

export async function productAdd(form) {
	return requestPost(api.ADD, form);
}

export async function productUpdate(form) {
	return requestPost(api.UPDATE, form);
}

export async function productSetEnabled(id, enable) {
	return requestPost(api.SET_ENABLE, { id, enable });
}
